// extracted by mini-css-extract-plugin
module.exports = {"popoverTitle":"popoverTitle___2PA4m","rules":"rules___3BTIu"};